//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
export default {
    async fetch() {
        await Promise.all([ 
            this.$store.dispatch('pagesStore/getPage', 'nieuws'),
            this.$store.dispatch('bannerStore/getBanner', 'collection'),
            this.$store.dispatch('resourcesStore/getResources', this.queries.news)
        ])
    },
    head() {
        return {
            title: this.pages.nieuws && this.pages.nieuws.seo ? this.pages.nieuws.seo.title : 'Nieuws | Meiden van Holland',
            meta: [
                { hid: 'title', name: 'title', content: this.pages.nieuws && this.pages.nieuws.seo ? this.pages.nieuws.seo.title : 'Nieuws | Meiden van Holland' },
                { hid: 'og:title', name: 'og:title', content: this.pages.nieuws && this.pages.nieuws.seo ? this.pages.nieuws.seo.title : 'Nieuws | Meiden van Holland' },
                { hid: 'description', name: 'description', content: this.pages.nieuws && this.pages.nieuws.seo ? this.pages.nieuws.seo.description : 'Nieuws over Meiden van Holland vind je hier.'},
                { hid: 'og:description', name: 'og:description', content: this.pages.nieuws && this.pages.nieuws.seo ? this.pages.nieuws.seo.description : 'Nieuws over Meiden van Holland vind je hier.' },
                { hid: 'og:url', name: 'og:url', content: process.env.FE_URL + '/nieuws' },
                { hid: 'keywords', name: 'keywords', content: this.pages.nieuws && this.pages.nieuws.seo ? this.pages.nieuws.seo.keywords : 'Meiden van Holland, nieuws'},
            ]
        }
    },
    components: {
        news: () => import('~/components/content/news/news'),
        dummyCollection: () => import('~/components/content/dummy/collection.vue'),
        banner: () => import('~/components/banner.vue'),
        about: () => import('~/components/about_section.vue')
    },
    computed: {
        ...mapState({
            queries: ({ resourcesStore: {queries} }) => queries,
            pages: ({ pagesStore: {pages} }) => pages,
            news: ({ resourcesStore: {news} }) => news,
            loading: ({ resourcesStore: { loading } }) => loading
        }),
    }
}
